import type { MovementConfig } from '../config/movements';
import { resolveStandardTransferType, resolveTransferOutDocSubType } from './postingVariant';

export function movementRequiresCustomerPosting(movement: MovementConfig): boolean {
  return movement.wizardKind !== 'relocation';
}

export type PostingPreview = {
  requiresCustomerDetails: boolean;
  sapField: string;
  sapValue: string;
  modeLabel: 'AUTO' | 'Manual' | 'N/A';
};

export function buildPostingPreview(
  movement: MovementConfig,
  useAutoTransferType: boolean
): PostingPreview {
  if (movement.wizardKind === 'relocation') {
    return {
      requiresCustomerDetails: false,
      sapField: 'TransferType',
      sapValue: movement.transferTypeFlat ?? '—',
      modeLabel: 'N/A',
    };
  }

  if (movement.wizardKind === 'transferOut') {
    const auto = useAutoTransferType && Boolean(movement.transferTypeKit);
    return {
      requiresCustomerDetails: true,
      sapField: 'DOC_SUB_TYPE',
      sapValue: resolveTransferOutDocSubType(movement, useAutoTransferType),
      modeLabel: auto ? 'AUTO' : 'Manual',
    };
  }

  const auto = useAutoTransferType && Boolean(movement.transferTypeKit);
  return {
    requiresCustomerDetails: true,
    sapField: 'TRANSFER_TYPE',
    sapValue: resolveStandardTransferType(movement, useAutoTransferType),
    modeLabel: auto ? 'AUTO' : 'Manual',
  };
}

export function formatCustomerDetailsLoadError(error: unknown): string {
  if (error && typeof error === 'object' && 'message' in error) {
    const msg = (error as { message: unknown }).message;
    if (typeof msg === 'string' && msg.trim()) return msg.trim();
  }
  if (error instanceof Error && error.message.trim()) return error.message.trim();
  return 'Failed to load customer details.';
}
